import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MaintenancePage from "./components/MaintenancePage/MaintenancePage";
import { isMaintenanceMode } from "./config/appMode";

const LiveApp = isMaintenanceMode ? null : require("./AppLive").default;

function App() {
  return (
    <BrowserRouter basename="/">
      {isMaintenanceMode ? (
        <Routes>
          <Route path="/" element={<MaintenancePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <LiveApp />
      )}
    </BrowserRouter>
  );
}

export default App;
